<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowNetHearingAidGrossMarginByAudiologist',
    extends: TableRowBase,
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        return this.getRatio(
          this.getYtdByField(yearObj, 'ha_gross_profit', throughMonth),
          this.getYtdByField(yearObj, 'number_providers', throughMonth),
        );
      },
    },
  };
</script>
